import React from 'react';
import styles from './Sparkline.module.scss';

const DEFAULT_WIDTH = 44;
const DEFAULT_HEIGHT = 16;
const PADDING = 2;
const MAX_VALUE = 100;

interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
}

export const Sparkline: React.FC<SparklineProps> = ({
  values,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
}) => {
  if (values.length < 2) return null;

  const x = (index: number) => PADDING + (index * (width - 2 * PADDING)) / (values.length - 1);
  const y = (value: number) => PADDING + (1 - value / MAX_VALUE) * (height - 2 * PADDING);
  const points = values.map((value, index) => `${x(index)},${y(value)}`).join(' ');

  return (
    <svg
      className={styles.sparkline}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      aria-hidden="true"
      focusable="false"
    >
      <polyline points={points} />
    </svg>
  );
};
